module.exports = __webpack_public_path__ + "img/solcan-tekla.93ec56b3.jpg";